export default function displayType({ sessionType, contentTypeGroupLabel }) {
  if (sessionType) return sessionType;
  if (contentTypeGroupLabel !== 'Sessions') {
    return 'Publication Only';
  }
  return 'Education Session';
}
